import { FaAward } from "react-icons/fa";
import HeroSection from "../../../../ReusableComponent/HeroSection"

const TournamentHeroSection=()=>{
  const stats = [
    { value: "$100K+", label: "Prize Pool" },
    { value: "10K+", label: "Active Players" },
    { value: "50+", label: "Weekly Contests" },
    { value: "200+", label: "Sponsor Companies" },
  ];

  return (
    <HeroSection
      title="Coding Tournaments"
      subtitle="Compete with developers worldwide and win exciting prizes"
      icon={<FaAward />}
      stats={stats}
    />
  );
}

export default TournamentHeroSection;